<div class="wrap">
  <div class="list">
    <div
      *ngFor="let deliveryItem of items"
      class="item"
      (click)="onItemClick(deliveryItem)"
    >
      <div
        class="order-item"
        [class.success]="
          (deliveryItem | getDeliveryForDateStatus) ===
            deliveryStatuses.CONFIRMED ||
          (deliveryItem | getDeliveryForDateStatus) ===
            deliveryStatuses.DELIVERED
        "
        [class.warning]="
          (deliveryItem | getDeliveryForDateStatus) ===
            deliveryStatuses.PENDING ||
          (deliveryItem | getDeliveryForDateStatus) ===
            deliveryStatuses.REFUNDED
        "
        [class.error]="
          (deliveryItem | getDeliveryForDateStatus) === deliveryStatuses.ERROR
        "
      >
        <div class="header"></div>

        <app-order-item
          [label]="deliveryItem.item.name"
          [price]="deliveryItem.item | getRelevantProductPrice | getPrimaryCurrencyPrice"
          [amount]="deliveryItem.quantity"
        ></app-order-item>

        <app-delivery-for-date-status
          [deliveryItem]="deliveryItem"
        ></app-delivery-for-date-status>
      </div>
    </div>
  </div>
</div>
